import { Component, OnInit, OnDestroy, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { KeyValue, Location } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { Subscription, fromEvent } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { map, startWith, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatSelectionList } from '@angular/material/list';
import { ApploadServiceService } from '../services/appload-service.service';
import { UserService } from '.././services/user.service';
import { PageEvent, SELECT_PANEL_INDENT_PADDING_X } from '@angular/material';
import { WizardHpModelFilterableBaseComponent } from '../base/wizard/wizard-hp-model-filterable-base-component';
import { HpService } from '../services/hp.service';
import { WizardHpModelFilterSelecteurPorteComponent } from './wizard-hp-model-filter-selecteur-porte-component';
import { WizardHpModelFilterTextSelecteurPorteComponent } from './wizard-hp-model-filter-text-selecteur-porte-component';
import { SimulateurComponent } from '../simulateur/simulateur.component';



@Component({
  selector: 'app-selecteur-porte',
  templateUrl: './selecteur-porte.component.html',
  styleUrls: ['./selecteur-porte.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelecteurPorteComponent extends WizardHpModelFilterableBaseComponent implements OnInit {
  @ViewChild(MatSelectionList, { static: true })
  @ViewChild('scrollContent', { static: false }) scrollContainer: ElementRef;
  @ViewChild('wizardElementsFilterMenu', { static: false }) wizardElementsFilterMenu : WizardHpModelFilterSelecteurPorteComponent;
  p: number = 1;
  pages = [];
  pageOfItems: Array<any>;
  panneaux = [];
  etape_show = false;
  mat_stepper_width = 132;
  panelStyleOpenState = false;
  panelTypeOpenState = false;
  panelVitrageOpenState = false;
  panelMateriauxOpenState = false;
  panelFilter = false;
  elementsByPage = 18;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  collections: any;
  materiaux: any
  current_game: any
  questionTitleAnswers: any;
  answers: any;
  panneau_url =  null; //"https://simuleo.herculepro.com/fdw";
  url_search = true;
  // MatPaginator Inputs
  length = 1000;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 15];
  pageEvent: PageEvent;
  activePageDataChunk = []
  object_catalog = "porte" ;
  currentGrpId: any;
  currentQstId:any;
  rootKeywordWindow = "OUVERTURE";
   constructor(chgDetectorRef: ChangeDetectorRef, private userService: UserService,
    hpService: HpService,
    router: Router,
    private deviceService: DeviceDetectorService,
    private location: Location) {
      super(chgDetectorRef, hpService,  router);
    this.getHpService().emitDataChange();
    this.panneau_url = this.getHpService().getUrlapi() + '/fdw';
    this.panneaux = this.getHpService().getPanneaux();
    this.pages = this.panneaux;
    this.p = 1;
    this.activePageDataChunk = this.panneaux.slice(0, this.pageSize);
    this.getHpService().setBooleanParam("loadCatalo",false)
    this.getHpService().getRootCategoryType();
    this.getHpService().emitDataChange();
    this.getHpService().setCurrentPage(this.getIndexNextUrl('selecteur-de-portes'));
    //this.rootKeywordWindow = this.getHpService().getC
  }

  ngOnChanges() {

  }

  ngOnInit() {

    super.ngOnInit();
    this.getHpService().setStatut_user(true);
    if (this.getHpService().getQuestionObject(this.getHpService().getRootCategoryType()) == undefined) {
      this.getRouter().navigate(['selecteur-maisons'])
    }
    this.doInitPaging();

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
      this.doInitPaging();
    });

    setTimeout(() => {
      this.etape_show = true;
      this.mat_stepper_width = this.mat_stepper_width + 33;
    }, 100);
  }

  doInitPaging() {
    if (this.getHpService().getIsDesktop() && !this.getHpService().getIsDkptMinWidth()) {
      this.elementsByPage = 12;
    } else if (this.getHpService().getIsDesktop() && this.getHpService().getIsDkptMinWidth()) {
      this.elementsByPage = 12;
    } else if (this.getHpService().getIsTablet()) {
      this.elementsByPage = 12;
    } else if (this.getHpService().getIsMobile()) {
      //sdans le cas des mobiles on desactive la pagination.
      this.elementsByPage = -1;
    }
  }
  getUrl(imgSubUrl) {
    return this.panneau_url + '/' + imgSubUrl;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

  onPageChanged(e) {
    let firstCut = e.pageIndex * e.pageSize;
    let secondCut = firstCut + e.pageSize;
    this.activePageDataChunk = this.panneaux.slice(firstCut, secondCut);
  }

  public selectItem(item) {
    this.getHpService().selectItem(item.name, this.toNextLink, this);
  }

  public onDataRetrieved(result : any) {
    this.panneaux = result.items;
    this.pages = this.panneaux;
    this.p = 1;
  }
  selectExpansionMenu(i,id,slug)
  {
    if(slug == "portes")
    {
      return;
    }
      
  this.getHpService().setStatut_user(false);
  this.object_catalog = slug;
  let item = this.getHpService().getAllCataglog()[slug]["catalogs"][0];
  this.getHpService().setCurrentProduct(slug);
  this.getHpService().setCatalogSlug(slug);
  this.getHpService().setCatalogIndex(i);
  this.getHpService().setListCatalogId(id);
  this.getHpService().loadMultiConfig(0,1); 
  let me = this;
  me.getHpService().initToken().then(function (result) { 
  me.getHpService().doInitDirectMultiProduct(0,1).then(function (result) {  
    console.log("result grpId " + me.getHpService().getQuestionObject(me.rootKeywordWindow).grpId) 
    console.log("result id " + me.getHpService().getQuestionObject(me.rootKeywordWindow).id)  
    console.log("result code " + me.getHpService().getQuestionObject(me.rootKeywordWindow).code);
    
  me.fetchAnswers(me.getHpService().getQuestionObject(me.rootKeywordWindow).grpId,
  me.getHpService().getQuestionObject(me.rootKeywordWindow).id,
  me.getHpService().getRootProductElt(),
  me.getHpService().getQuestionObject(me.rootKeywordWindow).code,
  me.getHpService().getQuestionObject(me.rootKeywordWindow),
  me.rootKeywordWindow,2)
  
     });  
   
});  
 
 
}
assignQuestionToAnswers(questionId: any, answers: any) {
  this.getHpService().assignQuestionToAnswers(questionId, answers);
}
assignMultiQuestionToAnswers(questionId: any, answers: any) {
  this.getHpService().assignQuestionToAnswers(questionId, answers);
}
fetchAnswers(grpId: any, categoryId: any, elementId: any, variable, code_type, key, index_) {
   
  this.getChangeDetectorRef().detectChanges();
  this.getHpService().emitDataChange();
    this.questionTitleAnswers = null;
    this.answers = null;
    this.currentGrpId = grpId;
    this.currentQstId = categoryId;
    this.getHpService().setCurrentProductIndex(1); 
    this.getHpService().setshowMenuWindows(true);
    let me =this;
    this.getHpService().fetchAnswers(this.getHpService().getCatId(), this.getHpService().getProductId(), categoryId,
      this.getHpService().getRootProductElt()).subscribe({
        next: (data:any) => {
         
          me.assignQuestionToAnswers(categoryId, data);
          me.answers = data;
          me.getHpService().setProduct_answers(data);
          console.log( me.getHpService().getProduct_answers())
        
          if (me.getHpService().getQuestionIsTitle(categoryId)) {
            let childQuestionId = me.getHpService().getLinkedSubQuestionId(categoryId);
            if (childQuestionId != null) {
                me.getHpService().fetchAnswers(categoryId, me.getHpService().getProductId(),
                childQuestionId,
                me.getHpService().getRootProductElt()).subscribe(subData => {
                  me.assignQuestionToAnswers(childQuestionId, subData);
                  me.questionTitleAnswers = subData; //this.answers;
                  me.getChangeDetectorRef().detectChanges();
                  me.getHpService().emitDataChange();
                  });
            }
          }
          me.getHpService().setCurrentProductIndex(1);
          me.getHpService().setshowMenuWindows(true);
          me.getChangeDetectorRef().detectChanges();
          me.getHpService().emitDataChange();
         me.toNextLink();
          
        },
        error: (error) => {
          console.log('error'); // Pas reponse de tout  avec erreur
        }
      });
  }
  // Preserve original property order
  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  // Order by ascending property value
  valueAscOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.value.localeCompare(b.value);
  }

  // Order by descending property key
  keyDescOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
  }

}
